var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed_formTip"},[_c('span',{staticClass:"txt"},[_vm._v("观看完视频课程，填写问卷表单即可取得证书～")]),_c('span',{staticClass:"btn",on:{"click":_vm.toInputForm}},[_vm._v("去填写")])])
}
var staticRenderFns = []

export { render, staticRenderFns }